export const SET_FORM_FIELD = 'signup/SET_FORM_FIELD';
export const LOADING = 'signup/LOADING';
export const ADD_COUPLE_SUCCESS = 'signup/ADD_COUPLE_SUCCESS';
export const SIGNUP_OWNER_SUCCESS = 'signup/SIGNUP_OWNER_SUCCESS';
export const ADD_BENEFICIARY = 'signup/ADD_BENEFICIARY';
export const CLEAR_BENEFICIARY_FORM = 'signup/CLEAR_BENEFICIARY_FORM';
export const EDIT_DEPENDENT = 'signup/EDIT_DEPENDENT';
export const REMOVE_COUPLE = 'signup/REMOVE_COUPLE';
export const REMOVE_BENEFICIARY = 'signup/REMOVE_BENEFICIARY';
export const EDIT_BENEFICIARY = 'signup/EDIT_BENEFICIARY';